import { Suspense } from "react";
import { CreateWizard } from "@/components/create-wizard";
import { Spinner } from "@/components/ui";

export default function StudioPage() {
  return (
    <div className="relative min-h-full">
      <Suspense
        fallback={
          <div className="grid min-h-[60vh] place-items-center text-muted">
            <Spinner className="size-6" />
          </div>
        }
      >
        <CreateWizard />
      </Suspense>
    </div>
  );
}
